<template>
  <div>
    <div class="body_center_left_content_article1" v-if="!article.images" @click="toArticleFun(article)">
      <!-- <img src="article.images[0]" /> -->
      <div class="title">{{article.content}}</div>
      <div class="msg_time"><span>{{article.creator.nickname}}</span><span class="time">{{timeToStr(article.createdDate)}}</span></div>
    </div>
    <div class="body_center_left_content_article1" v-else-if="!article.ad&&article.images.length<=1" @click="toArticleFun(article)">
      <img :src="article.images[0]" />
      <div class="title">{{article.title}}</div>
      <div class="msg_time"><span>{{article.creator.nickname}}</span><span class="time">{{timeToStr(article.createdDate)}}</span></div>
    </div>
    <div class="body_center_left_content_article2" v-else-if="!article.ad&&article.images.length>1">
      <div class="title">{{article.title}}</div>
      <div class="img_list">
        <img :src="item" v-for="(item, index) in article.images" :key="index" />
      </div>
      <div class="msg_time"><span>邦人NAVI</span><span class="time">2022-12-10</span></div>
    </div>
    <div class="body_center_left_content_ad" v-else-if="article.ad">
      <div class="title">{{article.title}}</div>
      <div class="img_list">
        <img :src="article.images[0]" />
      </div>
      <div class="msg_time"><div class="ad_icon">広告</div><span>{{article.creator.nickname}}</span><span class="time">{{timeToStr(article.createdDate)}}</span></div>
    </div>
  </div>
</template>

<script>
  import { timeToStr } from '@/assets/js/util'
  export default {
    props: {
      article: {
        type: Object,
        default: () => {
          return {}
        }
      },
    },
    components: {
    },
    data () {
      return {
      }
    },
    created () {
    },
    methods: {
      timeToStr (val) {
        return timeToStr(val)
      },
      toArticleFun(item) {
        this.$router.push('/article?articleId=' + item.id)
      },
    }
  }
</script>

<style scoped>
  .body_center_left_content_article1{
  padding: 17px 0px;
  position: relative;
  min-height: 108px;
  border-bottom: 1px solid #E8E8E8;
  cursor: pointer;
}
.body_center_left_content_article1 img{
  width: 192px;
  height: 108px;
  background: #999999;
  border-radius: 10px;
}
.body_center_left_content_article1 .title{
  width: 522px;
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  position: absolute;
  top: 27px;
  left: 206px;
}
.body_center_left_content_article1 .msg_time{
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 12px;
  position: absolute;
  top: 103px;
  left: 209px;
}
.body_center_left_content_article1 .msg_time .time{
  margin-left: 23px;
}
.body_center_left_content_article2{
  padding: 21px 0px;
  position: relative;
  border-bottom: 1px solid #E8E8E8;
  cursor: pointer;
}
.body_center_left_content_article2 .title{
  width: 730px;
  height: 19px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 19px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.body_center_left_content_article2 .img_list{
  margin-top: 13px;
  text-align: left;
}
.body_center_left_content_article2 .img_list img{
  width: 236px;
  height: 134px;
  border-radius: 10px;
  display: inline-block;
  margin-left: 10px;
}
.body_center_left_content_article2 .img_list img:first-child{
  margin-left: 0;
}
.body_center_left_content_article2 .msg_time{
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 12px;
  margin-top: 18px;
  margin-left: 6px;
}
.body_center_left_content_article2 .msg_time .time{
  margin-left: 20px;
}
.body_center_left_content_ad{
  padding-top: 27px;
  padding-bottom: 21px;
  border-bottom: 1px solid #E8E8E8;
  cursor: pointer;
}
.body_center_left_content_ad .title{
  width: 730px;
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.body_center_left_content_ad .img_list{
  margin-top: 19px;
  font-size: 0;
}
.body_center_left_content_ad .img_list img{
  width: 514px;
  height: 234px;
  background: #CCFFFF;
  border-radius: 10px;
}
.body_center_left_content_ad .msg_time{
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 23px;
  margin-top: 20px;
}
.body_center_left_content_ad .msg_time .ad_icon{
  display: inline-block;
  width: 47px;
  height: 23px;
  background: #FFFFFF;
  border: 1px solid #DDDDDD;
  border-radius: 5px;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: #FF0000;
  line-height: 23px;
  margin-right: 9px;
}
.body_center_left_content_ad .msg_time .time{
  margin-left: 14px;
}
</style>
